import { useQuery } from '@tanstack/react-query'
import { getRequiresEverifySweepPreview } from 'api/companies'
import { requiresEverifySweepPreviewKey } from './keys'

export const useRequiresEverifySweepPreviewQuery = (
  companyId: number,
  options?: { enabled?: boolean }
) => {
  return useQuery<number, Error>({
    queryKey: requiresEverifySweepPreviewKey(companyId),
    queryFn: () => getRequiresEverifySweepPreview(companyId),
    enabled: options?.enabled ?? true,
  })
}
